import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {FormControl} from '@angular/forms';
import {detailsExpand} from '../../../../../../common';
import {ApplicationDTO} from '../../../../../models/application/ApplicationDTO';
import {ApplicationPersonDTO} from '../../../../../models/application/ApplicationPersonDTO';
import {CreateNameValueDTO, NameValueDTO} from '../../../../../../common/models/NameValueDTO';
import {SmsService} from '../../../../../../pbm/services/sms.service';
import {SharedService} from '../../../../../../common/services/shared-service';
import {TableControl} from '../../../../../../common/models/TableControl';
import {PagedRequestDTO} from '../../../../../../common/models/PagedRequestDTO';
import {PbmRequestBuilder} from '../../../../../../pbm/services/pbm-request-builder';
import {PagedFilterDTO} from '../../../../../../common/models/PagedFilterDTO';
import {BaseSmsClassDirective} from '../../../../../../common/components/sms-table/base-sms-class.directive';

@Component({
  selector: 'greydom-application-smses',
  templateUrl: './application-smses.component.html',
  styleUrls: [
    '../../../../../../../../styles/global/_management-styles.scss',
    '../../../../../../../../styles/global/_dialog-styles.scss',
  ],
  animations: [detailsExpand],
})
export class ApplicationSmsesComponent extends BaseSmsClassDirective implements OnChanges {
  @Input() application: ApplicationDTO;

  persons: ApplicationPersonDTO[] = [];
  personsNameValueDTO: NameValueDTO[] = [];
  defaultPersonSelected: string;
  selectedApplicationIdControl = new FormControl();

  constructor(
    protected smsService: SmsService,
    protected sharedService: SharedService
  ) {
    super(smsService, sharedService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.application?.currentValue) {
      this.getPersonAndDependentsPersons();
    }
  }

  getPersonAndDependentsPersons(): void {
    this.persons = this.application.membership?.persons || [];
    this.personsNameValueDTO = this.persons
      .sort((a: ApplicationPersonDTO, b: ApplicationPersonDTO) => {

        // Note: In case dependentNumber is null use applicationPersonId

        if (a.dependentNumber && b.dependentNumber) {
          return a.dependentNumber.localeCompare(b.dependentNumber);
        }
        else {
          return a.applicationPersonId - b.applicationPersonId;
        }
      })
      .map(person =>
        CreateNameValueDTO(person.applicationPersonId, this.getDisplayString(person))
      );

    if (this.personsNameValueDTO.length > 0) {
      this.defaultPersonSelected = this.personsNameValueDTO[0]?.name;
      this.selectedApplicationIdControl.patchValue(this.personsNameValueDTO[0]?.value);
      this.getListOfSMS(this.smsTableControl);
    }
  }

  getDisplayString(person: ApplicationPersonDTO): string {
    if (!person) {
      return;
    }
    return `${person.firstName} ${person.lastName}`;
  }

  onSelectionChange(selectedPerson: NameValueDTO) {
    if (selectedPerson) {
      this.selectedApplicationIdControl.setValue(selectedPerson.value);
      this.getListOfSMS(this.smsTableControl);
    }
  }

  protected getListOfSMS(tableControl: TableControl): void {
    const pagedRequestDTO: PagedRequestDTO = PbmRequestBuilder.getListOfSMSPagedRequestDTO(tableControl);
    pagedRequestDTO.fieldMap = {};

    const personPagedFilterDTO: PagedFilterDTO = new PagedFilterDTO();
    personPagedFilterDTO.name = 'applicationPersonByApplicationPersonId.applicationPersonId';
    personPagedFilterDTO.value = this.selectedApplicationIdControl?.value;
    pagedRequestDTO.fieldMap['applicationPersonByApplicationPersonId'] = personPagedFilterDTO;


    this.smsService.getListOfSMS(pagedRequestDTO)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
          this.smsDataSource.data = response.resultList.map(item => ({
            ...item,
            sendSmsChecked: false,
            smsSentBusyCounter: 0
          }));
          this.smsTableControl.length = response.totalRecords;
        },
        error: (errorResponse) => {
          this.sharedService.openSnackBar(errorResponse.error.businessMessage, 'Dismiss');
        }
      });
  }
}

